import { render, staticRenderFns } from "./SegCapacitacion.vue?vue&type=template&id=6da1f8a0&scoped=true&"
import script from "./SegCapacitacion.vue?vue&type=script&lang=js&"
export * from "./SegCapacitacion.vue?vue&type=script&lang=js&"
import style0 from "./SegCapacitacion.vue?vue&type=style&index=0&id=6da1f8a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da1f8a0",
  null
  
)

export default component.exports